module.exports = __webpack_public_path__ + "img/PR12.b2605062.png";